import { RiArrowLeftLine } from '@remixicon/react';
import { Footer } from '../components/layout/Footer';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-surface-page">
      {/* Top bar */}
      <div className="bg-brand px-5 lg:px-10 py-4 flex items-center gap-4">
        <a href="/" className="flex items-center gap-1.5 text-white/80 hover:text-white font-display text-[14px] transition-colors">
          <RiArrowLeftLine className="h-4 w-4" />
          Retour
        </a>
        <img src="/new_assets/LogoH.svg" alt="idaNroh" className="h-8 w-auto" draggable={false} />
      </div>

      {/* Contenu */}
      <div className="max-w-[720px] mx-auto px-5 lg:px-8 py-10 pb-16">
        <div className="bg-white rounded-2xl border border-line-light p-8 lg:p-10">

          <h1 className="font-display font-bold text-[26px] text-ink mb-1">
            Conditions d'utilisation
          </h1>
          <p className="font-display text-[13px] text-ink-faint mb-8">
            Dernière mise à jour : juillet 2026
          </p>

          <Section title="Service gratuit">
            <p>
              idaNroh est un service entièrement gratuit, sans inscription requise. Son utilisation ne crée aucune relation contractuelle entre l'utilisateur et le service.
            </p>
          </Section>

          <Section title="Source des données">
            <p>
              Les horaires et informations de départ affichés proviennent de l'API publique SOGRAL/Mahatati. Ces données sont fournies à titre informatif uniquement et ne constituent pas un engagement de la part de SOGRAL ou d'idaNroh. idaNroh n'est pas affilié officiellement à SOGRAL.
            </p>
          </Section>

          <Section title="Prévisions d'affluence">
            <p>
              Les prévisions affichées sont calculées à partir de tendances statistiques observées sur des jours similaires (jour de la semaine, heure, saison). Elles sont indicatives et ne garantissent en aucun cas la disponibilité de places à bord. L'utilisateur est encouragé à se rendre à la gare en avance quelle que soit la prévision.
            </p>
          </Section>

          <Section title="Limitation de responsabilité">
            <p>
              idaNroh ne peut être tenu responsable des erreurs, omissions, retards ou indisponibilités dans les données affichées. En cas d'écart entre les informations du site et la réalité sur le terrain, c'est la réalité qui prévaut.
            </p>
          </Section>

          <Section title="Propriété intellectuelle">
            <p>
              Le code source, le design, les visuels et le contenu rédactionnel de ce service m'appartiennent. Toute reproduction, même partielle, sans autorisation préalable est interdite.
            </p>
          </Section>

          <Section title="Modifications" last>
            <p>
              Ces conditions peuvent être modifiées à tout moment et sans préavis. La version en vigueur est toujours celle accessible à cette adresse.
            </p>
          </Section>

        </div>
      </div>

      <Footer />
    </div>
  );
}

function Section({ title, children, last = false }: { title: string; children: React.ReactNode; last?: boolean }) {
  return (
    <div className={last ? '' : 'mb-8 pb-8 border-b border-surface-ui'}>
      <h2 className="font-display font-bold text-[17px] text-ink mb-3">{title}</h2>
      <div className="font-display text-[14px] text-ink-secondary leading-relaxed [&_strong]:font-semibold [&_strong]:text-ink">
        {children}
      </div>
    </div>
  );
}
